export default __webpack_public_path__ + "static/media/Vikendica 4.30577014.jpeg";